<template>
  <div class="form-check" :class="[inlineClass, {disabled: disabled}]">
    <label :for="cbId" class="form-check-label">
      <input :id="cbId"
             class="form-check-input"
             type="checkbox"
             :disabled="disabled"
             :checked="checked"
             @change="onChange"
      />
      <span class="form-check-sign"></span>
      <slot></slot>
    </label>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'l-checkbox',

  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },

  emits: ['update:checked'],

  data () {
    return {
      cbId: Math.random().toString(16).slice(2)
    }
  },

  computed: {
    inlineClass() {
      return this.inline ? 'checkbox-inline' : ''
    }
  },

  methods: {
    onChange(event) {
      const value = event.target.checked
      this.$emit('update:checked', event.target.checked)
    }
  },
});
</script>
